import { QueryClientProvider } from '@tanstack/react-query'
import { domAnimation, LazyMotion, MotionConfig } from 'motion/react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from '../ui/Toast.tsx'
import { TooltipProvider } from '../ui/Tooltip.tsx'
import { queryClient } from './queryClient.ts'
import { router } from './router.tsx'

/** `m.*` components only (LazyMotion strict): the full `motion.*` bundle never ships. */
export function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<LazyMotion features={domAnimation} strict>
				<MotionConfig reducedMotion="user">
					<TooltipProvider>
						<RouterProvider router={router} />
						<Toaster />
					</TooltipProvider>
				</MotionConfig>
			</LazyMotion>
		</QueryClientProvider>
	)
}
